import React from 'react';

import Badge from '@material-ui/core/Badge';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import EditIcon from '@material-ui/icons/Edit';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import FullscreenExitIcon from '@material-ui/icons/FullscreenExit';
import ListAltIcon from '@material-ui/icons/ListAlt';

import {
  closeCommunicationPanel,
  toggleCommunicationDraftsView,
  toggleCommunicationPanelExpanded,
  useCommunicationDraftCount,
  useIsCommunicationDraftsView,
  useIsCommunicationPanelExpanded
} from '../../../lib/stores/communication.store';
import { HeaderBar, HeaderSpacer, HeaderTitle } from './communication-panel.styles';

export const CommunicationPanelHeader: React.FC = () => {
  const isExpanded = useIsCommunicationPanelExpanded();
  const isDraftsView = useIsCommunicationDraftsView();
  const draftCount = useCommunicationDraftCount();
  // Tablet and below are always full-screen, so the expand toggle is hidden
  // there — collapsing to a 560px drawer on a small screen is never wanted.
  const theme = useTheme();
  const isTabletOrSmaller = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <HeaderBar>
      <HeaderTitle variant="h6">Communication</HeaderTitle>
      <HeaderSpacer />
      <Tooltip title={isDraftsView ? 'Back to compose' : 'Drafts'} arrow>
        <IconButton
          size="small"
          aria-label={isDraftsView ? 'Back to compose' : 'Show saved drafts'}
          onClick={toggleCommunicationDraftsView}
          color={isDraftsView ? 'primary' : 'default'}
        >
          {isDraftsView ? (
            <EditIcon />
          ) : (
            <Badge badgeContent={draftCount} color="primary" overlap="rectangular">
              <ListAltIcon />
            </Badge>
          )}
        </IconButton>
      </Tooltip>
      {!isTabletOrSmaller && (
        <Tooltip title={isExpanded ? 'Exit full screen' : 'Expand to full screen'} arrow>
          <IconButton
            size="small"
            aria-label={isExpanded ? 'Exit full screen' : 'Expand communication panel to full screen'}
            onClick={toggleCommunicationPanelExpanded}
          >
            {isExpanded ? <FullscreenExitIcon /> : <FullscreenIcon />}
          </IconButton>
        </Tooltip>
      )}
      <IconButton size="small" aria-label="Close communication panel" onClick={closeCommunicationPanel}>
        <CloseIcon />
      </IconButton>
    </HeaderBar>
  );
};
